Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Reanimated = void 0;
var _utils = require("../../utils");
var _Reanimated;
var Reanimated;
try {
    exports.Reanimated = Reanimated = require("react-native-reanimated");
} catch (e) {
    exports.Reanimated = Reanimated = undefined;
}
if (!((_Reanimated = Reanimated) != null && _Reanimated.useSharedValue)) {
    exports.Reanimated = Reanimated = undefined;
}
var _worklet_5035692407728_init_data = {
    code: "function anonymous(){const{tagMessage}=this.__closure;console.warn(tagMessage('Please use newer version of react-native-reanimated in order to control state of the gestures.'));}",
    location: "/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/reanimatedWrapper.ts",
    sourceMap: '{"version":3,"names":["anonymous","tagMessage","__closure","console","warn"],"sources":["/vercel/path0/example/node_modules/react-native-gesture-handler/src/handlers/gestures/reanimatedWrapper.ts"],"mappings":"AA6C+B,SAAAA,SAAMA,CAAA,QAAAC,UAAA,OAAAC,SAAA,CAEjCC,OAAO,CAACC,IAAI,CACVH,UAAU,CACR,gGACF,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
if (Reanimated !== undefined && !Reanimated.setGestureState) {
    Reanimated.setGestureState = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous() {
            console.warn((0, _utils.tagMessage)("Please use newer version of react-native-reanimated in order to control state of the gestures."));
        };
        anonymous.__closure = {
            tagMessage: _utils.tagMessage
        };
        anonymous.__initData = _worklet_5035692407728_init_data;
        anonymous.__workletHash = 5035692407728;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
}
